// removed by extract-text-webpack-plugin
module.exports = {"question_mult_choice_single_answer":"QuestionMultChoiceSingleAnswer--question_mult_choice_single_answer--3qHyy","question_mult_choice_single_answer_group":"QuestionMultChoiceSingleAnswer--question_mult_choice_single_answer_group--2UytD"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/QuestionMultChoiceSingleAnswer/QuestionMultChoiceSingleAnswer.css
// module id = 1028
// module chunks = 0